import signupImage from './signupImage';
import managedBackground from '../../utils/managedBackground';

export default function updateSignupModule() {
  const signupSource = $('.signup-section .signup-content');
  const signupFeature = $('.signup-section .emailSignup ');

  const titleString = $(signupSource).find('.signup-title').text();
  const paragraphString = $(signupSource).find('.signup-text').text();

  signupFeature.find('.emailSignupText').replaceWith(`
    <div class="signup-heading">
    <h3>${titleString}</h3>
    <p>${paragraphString}</p>
    </div>`);

  signupFeature
    .find('.emailInputField, .emailInputSubmit')
    .wrapAll('<div class="input-wrap"></div>');

  signupFeature.find('input').val('').attr('placeholder', 'Email Address');
  signupFeature.find('.emailInputSubmit .button').text('Subscribe');

  $(signupSource).remove();

  signupImage();

  managedBackground({
    widgetConfigName: 'backgroundSignup',
    widgetConfigOpts: backgroundSignupOpts,
    widgetConfigDestination: '.signup-section',
    widgetConfigContainerClass: 'managed-bg',
  });
}
